import React from 'react';

const TestimonialsSection = () => {
  const testimonials = [
    { 
      name: "Antonella - Parent", 
      text: "Sharon provides an educational experience second to none. She has been pivotal in Olivia's recovery and has actively supported her medical team. She has injected academic passion and confidence in my daughter, who is now a sociable, happy teenager.",
      rating: 5
    },
    { 
      name: "Nika - Parent of 9yo Student", 
      text: "Sharon found the right way to communicate with my son from day 1. He really enjoys the lessons and is able to concentrate when he is with Sharon. I was amazed to see how well he behaves and listens when he is with her.",
      rating: 5
    },
    { 
      name: "Alison De Cruz - Parent", 
      text: "Sharon taught my daughter in English Literature and Language, working intensively before her GCSE exams with the result being a grade 6 in both subjects. She continues to tutor in A level English and comes highly recommended.",
      rating: 5
    },
    { 
      name: "Debbie Potts - Parent", 
      text: "Sharon is a very caring and understanding person who gets the best out of her students. She has always been extremely punctual and well prepared for lessons. I have no hesitation in recommending Sharon.",
      rating: 5
    }
  ];

  const handleDownloadCV = () => {
    const link = document.createElement('a');
    link.href = '/sharon_cv.pdf';
    link.download = 'Sharon_Daley_CV.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section id="testimonials" className="section-padding bg-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-6 text-center">
          Testimonials
        </h2>
        <p className="text-center text-black text-lg mb-12 max-w-2xl mx-auto">
          What my students and their families say about working with me
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index} 
              className="card bg-beige p-8 rounded-2xl"
            >
              {/* Stars */}
              <div className="flex justify-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <svg 
                    key={i}
                    className="w-5 h-5 text-black" 
                    fill="currentColor" 
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
              
              {/* Quote */}
              <p className="text-black text-sm mb-6 italic leading-relaxed">
                "{testimonial.text}"
              </p>
              
              {/* Name */}
              <p className="text-black font-semibold text-center text-sm">
                — {testimonial.name}
              </p>
            </div>
          ))}
        </div>

        {/* Download CV Button */}
        <div className="text-center">
          <button 
            onClick={handleDownloadCV}
            className="btn-primary px-8 py-4 rounded-full font-medium text-lg inline-flex items-center"
          >
            <svg 
              className="w-5 h-5 mr-2" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
              />
            </svg>
            Download CV
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;